import React from 'react'
import "../stylesheets/E404SS.css"

function E404() {
  return (
    <div id='E404container'><span id='E404'>404 | Page does not exist</span></div>
  )
}

export default E404